import Image from "next/image";
import { InlineDiv, VerticalCenterDiv } from "../divs";
import ArrowRight from "@/assets/images/icons/arrow-right.svg";
import { OctagonButton } from "@/common/buttons";
import { AlmostBoldText } from "@/common/texts";
import { CityItemProps } from "@/types/components";
import { PRIMARY_BUTTON_COLOR } from "@/utils/constants";

const CityItem: React.FC<CityItemProps> = ({ city, onClick }) => {
  return (
    <InlineDiv
      onClick={() => {
        onClick();
      }}
      height="52px"
      width="100%"
      style={{
        marginBottom: "24px",
        cursor: "pointer",
        paddingLeft: "16px",
      }}
    >
      <VerticalCenterDiv style={{ marginTop: "-2px" }}>
        <AlmostBoldText fontSize="16px">{city}</AlmostBoldText>
      </VerticalCenterDiv>
      <VerticalCenterDiv right="5px">
        <OctagonButton
          style={{ borderRadius: "50px" }}
          width="36px"
          height="36px"
          backgroundColor={PRIMARY_BUTTON_COLOR}
        >
          <Image
            src={ArrowRight.src}
            alt="Arrow Right"
            width={18}
            height={18}
            style={{ width: "18px", height: "18px" }}
          />
        </OctagonButton>
      </VerticalCenterDiv>
    </InlineDiv>
  );
};

export default CityItem;
